<template>
    <div class="doc-page">
        <!-- 工具条 -->
        <div class="doc-toolbar">
            <div class="doc-toolbar__info">
                <span class="doc-toolbar__icon">
                    <el-icon>
                        <Collection />
                    </el-icon>
                </span>
                <span class="doc-toolbar__meta">
                    <span class="doc-toolbar__title">{{ this.currentCollected.name || '文集文档' }}</span>
                    <span class="doc-toolbar__subtitle">{{ this.createDocVisible ? '共 ' + (this.currentCollected.docCount || 0) + ' 篇文档' : '请选择文集' }}</span>
                </span>
            </div>

            <!-- 窄屏：文集选择（替代左侧列表） -->
            <el-select class="doc-toolbar__picker" popper-class="doc-picker-popper"
                :model-value="this.currentCollected.id" placeholder="选择文集" @change="selectCollectedById">
                <el-option-group label="我公开的协作">
                    <el-option v-for="item in this.collectedList.myCoop" :key="item.id" :label="optionLabel(item)"
                        :value="item.id" />
                </el-option-group>
                <el-option-group label="我参与的协作">
                    <el-option v-for="item in this.collectedList.joinCoop" :key="item.id" :label="optionLabel(item)"
                        :value="item.id" />
                </el-option-group>
                <el-option-group label="我公开的文集">
                    <el-option v-for="item in this.collectedList.myOpen" :key="item.id" :label="optionLabel(item)"
                        :value="item.id" />
                </el-option-group>
                <el-option-group label="私有文集">
                    <el-option v-for="item in this.collectedList.myPrivate" :key="item.id" :label="optionLabel(item)"
                        :value="item.id" />
                </el-option-group>
            </el-select>

            <div class="doc-toolbar__actions">
                <el-button class="toolbar-btn"
                    :class="this.createDocVisible ? 'toolbar-btn--ghost' : 'toolbar-btn--primary'"
                    @click="openCreateCollected">创建文集</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost"
                    @click="openEditCollected">编辑文集</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost"
                    @click="openMemberList">协作成员</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost toolbar-btn--danger"
                    @click="deleteCollected">删除文集</el-button>
                <span v-if="this.createDocVisible" class="doc-toolbar__split"></span>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--primary"
                    @click="createDoc">创建文档</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost"
                    @click="refreshDocList">刷新</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost"
                    :class="{ 'is-active': this.docNodeDragEnable }"
                    @click="this.docNodeDragEnable = !this.docNodeDragEnable">拖动排序</el-button>
                <el-button v-if="this.createDocVisible" class="toolbar-btn toolbar-btn--ghost"
                    @click="saveDocNodeDropOrder">保存排序</el-button>
            </div>
        </div>

        <div class="doc-page__body">
            <!-- 文集列表 -->
            <aside class="doc-nav">
                <el-menu :default-active="String(this.currentCollected.id || '')" :unique-opened="true"
                    @open="handleOpen" @close="handleClose">
                    <el-sub-menu index="1">
                        <template #title>
                            <span class="doc-nav__group">我公开的协作 ({{ this.collectedList.myCoop.length ?? 0 }})</span>
                        </template>
                        <el-menu-item v-for="item in this.collectedList.myCoop" :key="item.id.toString()"
                            :index="String(item.id)" @click="selectCollected(item)">
                            <span class="doc-nav__name">{{ item.name }}</span>
                            <span class="doc-nav__count">{{ item.docCount }}</span>
                            <el-tag v-show="item.isTemplet" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">模板</el-tag>
                            <el-tag v-show="item.isLoginAccess" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">登录</el-tag>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu index="2">
                        <template #title>
                            <span class="doc-nav__group">我参与的协作 ({{ this.collectedList.joinCoop.length ?? 0 }})</span>
                        </template>
                        <el-menu-item v-for="item in this.collectedList.joinCoop" :key="item.id.toString()"
                            :index="String(item.id)" @click="selectCollected(item)">
                            <span class="doc-nav__name">{{ item.name }}</span>
                            <span class="doc-nav__count">{{ item.docCount }}</span>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu index="3">
                        <template #title>
                            <span class="doc-nav__group">我公开的文集 ({{ this.collectedList.myOpen.length ?? 0 }})</span>
                        </template>
                        <el-menu-item v-for="item in this.collectedList.myOpen" :key="item.id.toString()"
                            :index="String(item.id)" @click="selectCollected(item)">
                            <span class="doc-nav__name">{{ item.name }}</span>
                            <span class="doc-nav__count">{{ item.docCount }}</span>
                            <el-tag v-show="item.isCoop" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">协作</el-tag>
                            <el-tag v-show="item.isTemplet" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">模板</el-tag>
                        </el-menu-item>
                    </el-sub-menu>
                    <el-sub-menu index="4">
                        <template #title>
                            <span class="doc-nav__group">私有文集 ({{ this.collectedList.myPrivate.length ?? 0 }})</span>
                        </template>
                        <el-menu-item v-for="item in this.collectedList.myPrivate" :key="item.id.toString()"
                            :index="String(item.id)" @click="selectCollected(item)">
                            <span class="doc-nav__name">{{ item.name }}</span>
                            <span class="doc-nav__count">{{ item.docCount }}</span>
                            <el-tag v-show="item.isCoop" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">协作</el-tag>
                            <el-tag v-show="item.isTemplet" type="warning" size="small" effect="plain"
                                class="doc-nav__tag">模板</el-tag>
                        </el-menu-item>
                    </el-sub-menu>
                </el-menu>
            </aside>

            <!-- 文档列表 -->
            <section class="doc-main">
                <div class="doc-head">
                    <div class="doc-cell doc-cell--title">标题</div>
                    <div class="doc-cell doc-cell--length">字数</div>
                    <div class="doc-cell doc-cell--owner">拥有者</div>
                    <div class="doc-cell doc-cell--time">最近更新</div>
                    <div class="doc-cell doc-cell--lock">锁(编辑中)</div>
                    <div class="doc-cell doc-cell--actions">操作</div>
                </div>
                <div class="doc-main__scroll">
                    <el-empty v-if="this.tableData.length === 0"
                        :description="this.createDocVisible ? '该文集暂无文档' : '请先选择文集'" />
                    <el-tree v-else class="doc-tree" :data="this.tableData" node-key="id" default-expand-all
                        :expand-on-click-node="false" :draggable="this.docNodeDragEnable" @node-drop="docNodeDrop">
                        <template #default="{ data }">
                            <div class="doc-row">
                                <div class="doc-cell doc-cell--title">
                                    <el-icon v-if="this.docNodeDragEnable" class="doc-row__drag">
                                        <Rank />
                                    </el-icon>
                                    <span class="doc-row__link" @click="previewDoc(data)">{{ data.title }}</span>
                                </div>
                                <div class="doc-cell doc-cell--length">
                                    <span class="doc-cell__label">字数</span>
                                    <span class="doc-row__link" @click="previewDoc(data)">{{ data.contentLength }}</span>
                                </div>
                                <div class="doc-cell doc-cell--owner">
                                    <span class="doc-cell__label">拥有者</span>
                                    <span>{{ data.ownerUser.realName }}</span>
                                </div>
                                <div class="doc-cell doc-cell--time">
                                    <span class="doc-cell__label">更新</span>
                                    <el-popover effect="light" trigger="hover" placement="top">
                                        <template #default>
                                            <p>{{ data.updateTime }}</p>
                                        </template>
                                        <template #reference>
                                            <span class="doc-row__time">{{ data.relativeUpdateTime }}</span>
                                        </template>
                                    </el-popover>
                                </div>
                                <div class="doc-cell doc-cell--lock">
                                    <div v-if="data.isCurrentUserLock">
                                        <el-tag v-if="data.lockUser" size="small" closable
                                            @close="docUnlock(data)">我</el-tag>
                                    </div>
                                    <div v-else>
                                        <div v-if="data.lockUserId != ''">
                                            <el-tag v-if="data.lockUser" size="small" type="warning" closable
                                                @close="docUnlock(data)">{{ data.lockUser.realName }}</el-tag>
                                            <el-tag v-else size="small" type="danger" closable
                                                @close="docUnlock(data)">未知</el-tag>
                                        </div>
                                    </div>
                                </div>
                                <div class="doc-cell doc-cell--actions">
                                    <el-button class="doc-action" link @click="createChildDoc(data.id)">创建子文档</el-button>
                                    <el-button class="doc-action" link @click="docEdit(data)">编辑</el-button>
                                    <el-popover placement="top-start" :width="200" trigger="click">
                                        <p>删除操作不可撤回，确定删除吗？</p>
                                        <div style="text-align: right; margin: 0">
                                            <el-button type="danger" size="small" @click="docDelete(data)">确定删除</el-button>
                                        </div>
                                        <template #reference>
                                            <el-button class="doc-action doc-action--danger" link>删除</el-button>
                                        </template>
                                    </el-popover>
                                </div>
                            </div>
                        </template>
                    </el-tree>
                </div>
            </section>
        </div>
    </div>
    <el-backtop></el-backtop>

    <!-- Form 创建/编辑文集 -->
    <el-dialog class="doc-dialog" :title="this.dialogFormMode == 'create' ? '创建文集' : '编辑文集'"
        v-model="dialogFormVisible" width="min(560px, 92vw)">
        <el-form :model="collectedForm" :label-width="formLabelWidth">
            <el-form-item label="名称">
                <el-input v-model="collectedForm.name" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="描述">
                <el-input type="textarea" maxlength="65535" show-word-limit :rows="6" placeholder="请输入内容"
                    v-model="collectedForm.description"></el-input>
            </el-form-item>
            <el-form-item label="公开">
                <el-switch v-model="collectedForm.isOpen" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                <span v-if="collectedForm.isOpen" class="doc-dialog__tips">在团队内可见</span>
                <span v-else class="doc-dialog__tips">自己及协作成员可见</span>
            </el-form-item>
            <el-form-item label="需登录查看">
                <el-switch v-model="collectedForm.isLoginAccess" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                <span class="doc-dialog__tips">设置是否登录后才能获取文档内容</span>
            </el-form-item>
            <el-form-item label="作为模板">
                <el-switch v-model="collectedForm.isTemplet" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
                <span class="doc-dialog__tips">为文档编写提供模板，不可被搜索</span>
            </el-form-item>
            <el-form-item label="所属团队">
                <el-select v-model="this.collectedForm.teamIdList" multiple placeholder="可选择已加入的团队"
                    style="width: 100%">
                    <el-option v-for="item in this.team.myJoin" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <span class="doc-dialog__tips">选取后，仅对应团队可见</span>
            </el-form-item>
        </el-form>
        <template #footer>
            <div class="doc-dialog__foot">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveCollected">保 存</el-button>
            </div>
        </template>
    </el-dialog>

    <!-- Form 协作成员 -->
    <el-dialog class="doc-dialog" title="协作成员" v-model="dialogMemberVisible" width="min(720px, 92vw)">
        <el-row style="margin-bottom: 20px">
            <el-alert title="协作成员拥有编辑权限，可编辑 “文集” 或 “文档”， 同时可以邀请其他成员进入协作" type="warning" :closable="false" />
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="doc-member">
                    <el-transfer v-model="memberId" :props="{ key: 'id', label: 'realName' }"
                        style="text-align: left; display: inline-block" filterable :titles="['用户列表', '参与成员']"
                        :button-texts="['移除', '添加']" :format="{ noChecked: '${total}', hasChecked: '${checked}/${total}' }"
                        :data="allUser" @change="handleChange">
                        <template #default="{ option }">
                            <span>{{ option.realName }}</span>
                        </template>
                    </el-transfer>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" style="text-align: center; margin-top: 24px">
                <el-button type="primary" @click="saveMember">保存参与成员列表</el-button>
            </el-col>
        </el-row>
    </el-dialog>
</template>

<script>
import { ElMessage } from 'element-plus';
import request from '../../../utils/request.js';
import _ from 'lodash';
export default {
    data() {
        return {
            docNodeDragEnable: false,
            rightValue: [],
            currentCollected: {},
            tableData: [],
            dialogFormMode: 'create',
            dialogFormVisible: false,
            dialogMemberVisible: false,
            createDocVisible: false,
            collectedForm: {
                name: '',
                description: '',
                isOpen: false,
                isTemplet: false,
                teamIdList: []
            },
            formLabelWidth: '120px',
            memberUser: [],
            otherUser: [],
            allUser: [],
            memberId: [],
            mineList: [],
            coopList: [],
            collectedList: {
                myCoop: [], // 我发起的协作
                joinCoop: [], // 我加入的协作（别人创建的）
                myOpen: [], // 我公开的文集
                myPrivate: [] // 私有文集
                // myAll: [] // 我的全部
            },
            team: {
                myJoin: []
            }
        };
    },
    mounted() {
        this.loadCollected();
        window.addEventListener('storage', this.HandleUiMsg);
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.HandleUiMsg);
    },
    components: {},
    methods: {
        HandleUiMsg(e) {
            if (e.key == 'ui-msg') {
                console.log(e.key, e.newValue, e.oldValue);
                if (JSON.parse(e.newValue).element == 'doc') {
                    this.loadCollected();
                    this.refreshDocList();
                }
            }
        },
        loadMyJoinTeam() {
            return request({
                url: '/team/getMyJoinTeams',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.team.myJoin = res.data;
                }
            });
        },
        loadCollected() {
            return request({
                url: '/collected/list',
                method: 'post',
                data: { token: this.$store.state.user.token }
            }).then(res => {
                if (res.code == 0) {
                    this.mineList = res.meta.mine;
                    this.coopList = res.meta.coop;

                    // 归类不同类别的文集
                    if (res.meta.mine) {
                        this.collectedList.myCoop = _.filter(res.meta.mine, { isCoop: true, isOpen: true }); // 我公开的协作
                        this.collectedList.myOpen = _.filter(res.meta.mine, { isCoop: false, isOpen: true }); // 我公开的文集
                        this.collectedList.myPrivate = _.filter(res.meta.mine, { isOpen: false }); // 私有文集
                    }
                    this.collectedList.joinCoop = res.meta.coop; // 我参与的协作
                }
            });
        },
        handleChange(value, direction, movedKeys) {
            console.log(value, direction, movedKeys);
        },
        // 左侧菜单展开
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        // 左侧菜单收起
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        // 窄屏下拉的选项文案：名称 + 文档数
        optionLabel(item) {
            return item.name + ' (' + (item.docCount ?? 0) + ')';
        },
        // 窄屏下拉选择文集
        selectCollectedById(collectedId) {
            const allCollected = [
                ...this.collectedList.myCoop,
                ...this.collectedList.joinCoop,
                ...this.collectedList.myOpen,
                ...this.collectedList.myPrivate
            ];
            const collected = allCollected.find(o => o.id === collectedId);
            if (collected) {
                this.selectCollected(collected);
            }
        },
        selectCollected(data) {
            this.currentCollected = data;
            this.createDocVisible = true;
            request({
                url: '/doc/list',
                method: 'post',
                data: {
                    collectedId: this.currentCollected.id
                }
            }).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data;
                }
            });
        },
        refreshDocList() {
            request({
                url: '/doc/list',
                method: 'post',
                data: {
                    collectedId: this.currentCollected.id
                }
            }).then(res => {
                if (res.code == 0) {
                    this.tableData = res.data;
                }
            });
        },
        openCreateCollected() {
            console.log('创建文集');
            this.dialogFormMode = 'create';
            this.collectedForm.name = '';
            this.collectedForm.description = '';
            this.collectedForm.teamIdList = [];
            this.collectedForm.isOpen = false;
            this.collectedForm.isTemplet = false;
            this.collectedForm.isLoginAccess = false;
            this.dialogFormVisible = true;
            this.loadMyJoinTeam();
        },
        openEditCollected() {
            console.log('编辑文集');
            this.dialogFormMode = 'edit';
            this.collectedForm.name = this.currentCollected.name;
            this.collectedForm.description = this.currentCollected.description;
            this.collectedForm.teamIdList = this.currentCollected.teamIdList;
            this.collectedForm.isOpen = this.currentCollected.isOpen;
            this.collectedForm.isLoginAccess = this.currentCollected.isLoginAccess;
            this.collectedForm.isTemplet = this.currentCollected.isTemplet;
            this.dialogFormVisible = true;
            this.loadMyJoinTeam();
        },
        // 打开协作成员弹框，并可编辑成员
        openMemberList() {
            this.dialogMemberVisible = true;
            return request({
                url: '/collected/getMember',
                method: 'post',
                data: { id: this.currentCollected.id }
            }).then(res => {
                if (res.code == 0) {
                    this.memberId = res.meta.memberId;
                    this.memberUser = res.meta.memberUser;
                    this.otherUser = res.meta.otherUser;
                    this.allUser = res.meta.allUser;
                }
            });
        },
        saveMember() {
            return request({
                url: '/collected/saveMember',
                method: 'post',
                data: {
                    id: this.currentCollected.id,
                    memberId: this.memberId
                }
            }).then(res => {
                if (res.code == 0) {
                    this.dialogMemberVisible = false;
                }
            });
        },
        saveCollected() {
            if (this.dialogFormMode == 'create') {
                return request({
                    url: '/collected/create',
                    method: 'post',
                    data: {
                        name: this.collectedForm.name,
                        description: this.collectedForm.description,
                        teamIdList: this.collectedForm.teamIdList,
                        token: this.$store.state.user.token,
                        isOpen: this.collectedForm.isOpen,
                        isLoginAccess: this.collectedForm.isLoginAccess,
                        isTemplet: this.collectedForm.isTemplet
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadCollected();
                    }
                });
            }
            if (this.dialogFormMode == 'edit') {
                return request({
                    url: '/collected/edit',
                    method: 'post',
                    data: {
                        id: this.currentCollected.id,
                        name: this.collectedForm.name,
                        description: this.collectedForm.description,
                        teamIdList: this.collectedForm.teamIdList,
                        token: this.$store.state.user.token,
                        isOpen: this.collectedForm.isOpen,
                        isLoginAccess: this.collectedForm.isLoginAccess,
                        isTemplet: this.collectedForm.isTemplet
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.dialogFormVisible = false;
                        this.loadCollected();
                        this.selectCollected(res.meta.docCollected);
                    }
                });
            }
        },
        deleteCollected() {
            return request({
                url: '/collected/delete',
                method: 'post',
                data: {
                    id: this.currentCollected.id,
                    token: this.$store.state.user.token
                }
            }).then(res => {
                if (res.code == 0) {
                    this.currentCollected = {};
                    this.createDocVisible = false;
                    this.loadCollected();
                }
            });
        },
        createDoc() {
            console.log('创建文档');

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.currentCollected.id, docId: '_create', parentDocId: '_blank', copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
        },
        createChildDoc(parentDocId) {
            console.log('创建子文档');

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.currentCollected.id, docId: '_create', parentDocId: parentDocId, copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
        },
        // 查看
        previewDoc(row) {
            console.log('查看');

            let routeData = this.$router.resolve({
                name: 'collected',
                params: { collectedId: this.currentCollected.id, docId: row.id }
            });
            window.open(routeData.path, '_blank');
        },
        // 编辑
        docEdit(row) {
            console.log('编辑');
            console.log(row);
            let parentDocId = '_blank';
            if (row.parentDocId != '') parentDocId = row.parentDocId;

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.currentCollected.id, docId: row.id, parentDocId: parentDocId, copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
        },
        // 解锁
        docUnlock(row) {
            console.log('解锁:' + row.id);
            return request({
                url: '/doc/unlock',
                method: 'post',
                data: {
                    id: row.id.toString()
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg || '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                    });

                    this.selectCollected(this.currentCollected);
                } else {
                    ElMessage({
                        message: res.msg || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    });
                }
            });
        },
        // 删除
        docDelete(row) {
            console.log('删除');
            return request({
                url: '/doc/delete',
                method: 'post',
                data: {
                    id: row.id.toString()
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg || '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                    });

                    this.selectCollected(this.currentCollected);
                } else {
                    ElMessage({
                        message: res.msg || 'Error',
                        type: 'error',
                        duration: 5 * 1000
                    });
                }
            });
        },
        setOrder(row, vector) {
            console.log('排序:' + row.id);
            return request({
                url: '/collected/setOrder',
                method: 'post',
                data: {
                    collectedId: this.currentCollected.id,
                    docId: row.id,
                    vector: vector
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: res.msg || '操作成功',
                        type: 'success',
                        duration: 5 * 1000
                    });

                    this.selectCollected(this.currentCollected);
                }
            });
        },
        docNodeDrop(draggingNode, dropNode, dropType, ev) {
            // console.log('tree drag end:', dropNode && dropNode.label, dropType);
            // console.log(this.tableData);
        },
        /**
         * 保存拖动的排序
         */
        saveDocNodeDropOrder() {
            console.log('整理层级关系');
            if (this.tableData.length > 0) {
                var result = new Array();
                for (var i = 0; i < this.tableData.length; i++) {
                    result.push({ id: this.tableData[i].id, pid: '', level: 0 });
                    result.push(...this.genDocLevelData(this.tableData[i], 1));
                }
                console.log(result);

                return request({
                    url: '/collected/freeOrder',
                    method: 'post',
                    data: {
                        docList: result
                    }
                }).then(res => {
                    if (res.code == 0) {
                        ElMessage({
                            message: '操作成功',
                            type: 'success',
                            duration: 1 * 1000
                        });

                        this.selectCollected(this.currentCollected);
                    }
                });
            }
            console.log('以上');
        },
        genDocLevelData(parentDoc, level) {
            var result = new Array();
            if (parentDoc && parentDoc.children && parentDoc.children.length > 0) {
                for (var i = 0; i < parentDoc.children.length; i++) {
                    result.push({ id: parentDoc.children[i].id, pid: parentDoc.id, level: level });
                    result.push(...this.genDocLevelData(parentDoc.children[i], level + 1));
                }
            }
            return result;
        }
    }
};
</script>

<style scoped>
/* ===================== 文集文档 ===================== */
.doc-page {
    --doc-text: #1f2d3d;
    --doc-sub: #5b6a80;
    --doc-muted: #8a94a6;
    --doc-line: #eef1f6;
    --doc-border: #e6eaf0;

    /* 局部覆盖主色，避免影响其它页面 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    display: flex;
    flex-direction: column;
    height: 100%;
    color: var(--doc-text);
}

/* ---------- 工具条 ---------- */
.doc-page .doc-toolbar {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
    padding: 10px 16px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    border: 1px solid #ebeef5;
    border-radius: 12px;
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}
.doc-toolbar__info {
    display: flex;
    align-items: center;
    min-width: 0;
}
.doc-toolbar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #79bbff 0%, #337ecc 100%);
    box-shadow: 0 8px 16px -10px rgba(51, 126, 204, 0.9);
}
.doc-toolbar__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.doc-toolbar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #1f2d3d;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.doc-toolbar__subtitle {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb2;
}
/* 文集下拉选择：仅窄屏显示（替代左侧列表） */
.doc-toolbar__picker {
    display: none;
}
.doc-toolbar__actions {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 8px;
}
.doc-toolbar__split {
    width: 1px;
    height: 18px;
    margin: 0 10px;
    background-color: #e4e7ed;
}

/* ---------- 工具条按钮（ghost / primary / danger） ---------- */
.doc-page .toolbar-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    transition: all 0.2s ease;
}
.doc-page .toolbar-btn + .toolbar-btn {
    margin-left: 8px;
}
.doc-page .toolbar-btn--ghost {
    color: #606266;
    background-color: #fff;
    border-color: #e4e7ed;
}
.doc-page .toolbar-btn--ghost:hover,
.doc-page .toolbar-btn--ghost:focus {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
    border-color: var(--el-color-primary-light-5);
    transform: translateY(-1px);
    box-shadow: 0 10px 18px -12px rgba(47, 111, 237, 0.9);
}
.doc-page .toolbar-btn--danger:hover,
.doc-page .toolbar-btn--danger:focus {
    color: #f56c6c;
    background-color: #fef0f0;
    border-color: #fab6b6;
    box-shadow: 0 10px 18px -12px rgba(245, 108, 108, 0.9);
}
/* 切换态（拖动排序）：写在 hover 之后，保证选中项 hover 不回退 */
.doc-page .toolbar-btn--ghost.is-active {
    color: var(--el-color-primary);
    background-color: var(--el-color-primary-light-9);
    border-color: var(--el-color-primary-light-5);
}
.doc-page .toolbar-btn--primary {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #2f6fed 0%, #2659be 100%);
    box-shadow: 0 10px 20px -12px rgba(47, 111, 237, 1);
}
.doc-page .toolbar-btn--primary:hover,
.doc-page .toolbar-btn--primary:focus {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #4b83f0 0%, #2f6fed 100%);
    transform: translateY(-1px);
    box-shadow: 0 14px 24px -12px rgba(47, 111, 237, 1);
}

/* ---------- 主体：左列表 + 右文档区 ---------- */
.doc-page .doc-page__body {
    display: flex;
    flex: 1;
    min-height: 0;
    gap: 14px;
    margin-top: 14px;
}

/* 左侧文集列表 */
.doc-page .doc-nav {
    flex: 0 0 250px;
    min-width: 0;
    overflow-y: auto;
    padding: 8px;
    border: 1px solid var(--doc-border);
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}
.doc-page .doc-nav :deep(.el-menu) {
    border-right: 0;
    background-color: transparent;
}
.doc-page .doc-nav :deep(.el-sub-menu__title) {
    display: flex;
    align-items: center;
    height: 34px;
    line-height: 34px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    color: var(--doc-sub);
    transition: background-color 0.2s, color 0.2s;
}
.doc-page .doc-nav :deep(.el-sub-menu__title:hover) {
    background-color: #f2f5fa;
    color: var(--doc-text);
}
.doc-page .doc-nav :deep(.el-menu-item) {
    display: flex;
    align-items: center;
    height: 34px;
    line-height: 34px;
    border-radius: 8px;
    font-size: 13px;
    color: var(--doc-sub);
    transition: background-color 0.2s, color 0.2s;
}
.doc-page .doc-nav :deep(.el-menu-item:hover) {
    background-color: #f2f5fa;
    color: var(--doc-text);
}
/* 选中态：浅蓝底 + 主色字 */
.doc-page .doc-nav :deep(.el-menu-item.is-active) {
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
    font-weight: 600;
}
.doc-nav__group {
    font-size: 13px;
    font-weight: 600;
}
.doc-nav__name {
    flex: 1 1 auto;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.doc-nav__count {
    flex: none;
    margin-left: 4px;
    font-size: 11px;
    color: var(--doc-muted);
}
.doc-nav__tag {
    flex: none;
    margin-left: 4px;
}

/* 右侧文档区 */
.doc-page .doc-main {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 0;
    overflow: hidden;
    border: 1px solid var(--doc-border);
    border-radius: 14px;
    background-color: #fff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}
.doc-page .doc-main__scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
}

/* 列表表头 */
.doc-page .doc-head {
    display: flex;
    flex: none;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border-bottom: 1px solid var(--doc-line);
    background-color: #f7f9fc;
    font-size: 12px;
    font-weight: 600;
    color: var(--doc-muted);
}
.doc-page .doc-head .doc-cell--title {
    padding-left: 28px;
}

/* 列宽（表格头与行共用） */
.doc-page .doc-cell {
    display: flex;
    align-items: center;
    min-width: 0;
    padding: 0 6px;
}
.doc-page .doc-cell--title {
    flex: 1 1 auto;
    min-width: 0;
}
.doc-page .doc-cell--length {
    flex: 0 0 64px;
}
.doc-page .doc-cell--owner {
    flex: 0 0 96px;
}
.doc-page .doc-cell--time {
    flex: 0 0 110px;
}
.doc-page .doc-cell--lock {
    /* 比原来宽 14px：容纳可关闭 tag 的关闭图标 */
    flex: 0 0 104px;
}
.doc-page .doc-cell--actions {
    /* 收紧到刚好容纳 3 个操作；省下的宽度自动归标题列 */
    flex: 0 0 160px;
}
/* 窄屏行内的字段标签：桌面由表头承担，故默认隐藏 */
.doc-page .doc-cell__label {
    display: none;
}

/* 文档行 */
.doc-page .doc-tree :deep(.el-tree-node__content) {
    height: auto;
    min-height: 40px;
    line-height: 1.4;
    border-bottom: 1px solid var(--doc-line);
    transition: background-color 0.2s;
}
.doc-page .doc-tree :deep(.el-tree-node__content:hover) {
    background-color: #f6f9ff;
}
.doc-row {
    display: flex;
    flex: 1;
    align-items: center;
    min-width: 0;
    padding: 6px 12px;
}
.doc-row__drag {
    flex: none;
    margin-right: 4px;
    color: var(--doc-muted);
}
.doc-row__link {
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: var(--doc-text);
    cursor: pointer;
    transition: color 0.2s;
}
.doc-row__link:hover {
    color: var(--el-color-primary);
}
.doc-row__time {
    white-space: nowrap;
    color: var(--doc-sub);
}
.doc-page .doc-action {
    height: auto;
    padding: 0;
    font-size: 12px;
}
.doc-page .doc-action + .doc-action {
    margin-left: 10px;
}
.doc-page .doc-action--danger {
    color: #f56c6c;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    /* 窄屏统一交给框架内容区滚动，避免与内部滚动条叠加 */
    .doc-page {
        display: block;
        height: auto;
    }
    .doc-page .doc-page__body {
        display: block;
        margin-top: 12px;
    }
    .doc-page .doc-nav {
        display: none;
    }
    .doc-page .doc-toolbar {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
    }
    .doc-page .doc-toolbar__picker {
        display: block;
        width: 100%;
    }
    .doc-page .doc-toolbar__split {
        display: none;
    }
    .doc-page .doc-main {
        overflow: visible;
    }
    .doc-page .doc-main__scroll {
        overflow: visible;
    }
    /* 表头在窄屏无意义，行改为「标题 / 元信息 / 操作」三行，并给元信息补上字段标签 */
    .doc-page .doc-head {
        display: none;
    }
    .doc-page .doc-row {
        flex-wrap: wrap;
        row-gap: 6px;
        padding: 10px 12px;
    }
    .doc-page .doc-cell--title {
        flex: 1 1 100%;
        font-size: 14px;
        font-weight: 500;
    }
    .doc-page .doc-cell--length,
    .doc-page .doc-cell--owner,
    .doc-page .doc-cell--time,
    .doc-page .doc-cell--lock {
        flex: 0 0 auto;
        padding: 0 12px 0 0;
        font-size: 12px;
        color: var(--doc-sub);
    }
    /* 窄屏元信息统一用次级色，避免与标题抢视线 */
    .doc-page .doc-cell--length .doc-row__link {
        color: var(--doc-sub);
    }
    .doc-page .doc-cell__label {
        display: inline-block;
        margin-right: 4px;
        font-size: 11px;
        color: #aab4c4;
    }
    .doc-page .doc-cell--actions {
        flex: 1 1 100%;
        padding: 0;
        margin-top: 2px;
    }
}
</style>

<!-- 弹窗会 teleport 到 body，样式需放在非 scoped 块并带唯一前缀 -->
<style>
.doc-dialog {
    /* 主色令牌需在此再声明一遍，弹窗取不到页面作用域 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    max-width: calc(100vw - 32px);
    border-radius: 14px;
    box-shadow: 0 18px 50px -12px rgba(28, 47, 84, 0.22);
}
.doc-dialog .el-dialog__header {
    margin-right: 0;
    padding: 22px 24px 0;
}
.doc-dialog .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: #1f2d3d;
}
.doc-dialog .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
}
.doc-dialog .el-dialog__body {
    padding: 18px 24px 4px;
}
.doc-dialog .el-dialog__footer {
    padding: 0 24px 22px;
}
.doc-dialog .el-form-item {
    margin-bottom: 18px;
}
.doc-dialog .el-form-item__label {
    font-size: 13px;
    font-weight: 500;
    line-height: 1.4;
    color: #8a94a6;
}
.doc-dialog__tips {
    padding-left: 10px;
    font-size: 12px;
    color: #8a94a6;
}
.doc-dialog__foot {
    display: flex;
    gap: 10px;
}
.doc-dialog__foot .el-button {
    flex: 1 1 0;
    height: 40px;
    margin-left: 0;
    border-radius: 10px;
}
.doc-member {
    text-align: center;
    overflow-x: auto;
}

/* ---------- 窄屏文集下拉：分组标题做成显眼的栏目条 ---------- */
.doc-picker-popper .el-select-dropdown {
    border: 1px solid #e6eaf0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 30px -12px rgba(28, 47, 84, 0.22);
}
/* 栏目条：浅蓝底 + 主色字 + 左侧渐变竖条 */
.doc-picker-popper .el-select-group__title {
    position: relative;
    height: 30px;
    padding: 0 14px 0 16px;
    line-height: 30px;
    background-color: #eaf1fd;
    color: #2f6fed;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.2px;
}
.doc-picker-popper .el-select-group__title::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 7px;
    width: 3px;
    height: 12px;
    margin-top: -6px;
    border-radius: 2px;
    background: linear-gradient(180deg, #6a9cff, #3f6fff);
}
/* 栏目之间断开 */
.doc-picker-popper .el-select-group__wrap:not(:last-of-type) {
    padding-bottom: 8px;
    border-bottom: 1px solid #eef1f6;
}
/* 选项：缩进到栏目之下，形成「栏目 → 条目」的递进关系 */
.doc-picker-popper .el-select-dropdown__item {
    height: 34px;
    padding: 0 14px 0 30px;
    line-height: 34px;
    font-size: 13px;
    color: #5b6a80;
}
.doc-picker-popper .el-select-dropdown__item:hover,
.doc-picker-popper .el-select-dropdown__item.is-hovering {
    background-color: #f6f9ff;
    color: #2f6fed;
}
.doc-picker-popper .el-select-dropdown__item.is-selected {
    color: #2f6fed;
    font-weight: 600;
}

/* ---------- 小尺寸设备适配 ---------- */
@media (max-width: 768px) {
    /* 穿梭框面板过宽会撑破弹窗，窄屏缩窄面板 */
    .doc-dialog .el-transfer-panel {
        width: 110px;
    }
}
</style>
